import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Centrale } from '@urbasolar_dev/urbaconnect-types'

import { useCustomTranslation } from '../../../infrastructure/translation/useCustomTranslation'
import { useStore } from '../../../application/store/store'
import { SpanUnselect } from './plantSearch.styles'

type PlantSearchSelectedProps = {
  selectedPlant: Centrale | null
  title: string
}

export const PlantSearchSelected = (props: PlantSearchSelectedProps): React.ReactElement => {
  const store = useStore()
  const { selectedPlant, title } = props
  const { t } = useCustomTranslation('common')
  return (
    <div>
      {title}
      {selectedPlant ? (
        <span>
          {` / ${selectedPlant.nom}`}
          <SpanUnselect role="button" onClick={store.unsetPlantSelected}>
            <FontAwesomeIcon icon="times" />
          </SpanUnselect>
        </span>
      ) : (
        <span>{` / ${t('all_plants')}`}</span>
      )}
    </div>
  )
}
